import React, { createContext, useContext, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const DialogContext = createContext(null);

export function DialogProvider({ children }) {
  const [state, setState] = useState({
    open: false,
    type: "alert",
    title: "",
    message: "",
    resolve: null,
  });
  const { t } = useTranslation("smallCompnenets");

  const alert = (message, title = t("dialog.defaultAlertTitle")) => {
    return new Promise((resolve) => {
      setState({
        open: true,
        type: "alert",
        title: title,
        message: message,
        resolve,
      });
    });
  };

  const confirm = (message, title = t("dialog.defaultConfirmTitle")) => {
    return new Promise((resolve) => {
      setState({
        open: true,
        type: "confirm",
        title: title,
        message: message,
        resolve,
      });
    });
  };

  const close = (result = undefined) => {
    if (state.resolve) state.resolve(result);
    setState({
      open: false,
      type: "alert",
      title: "",
      message: "",
      resolve: null,
    });
  };

  return (
    <DialogContext.Provider value={{ alert, confirm }}>
      {children}
      <Dialog
        open={state.open}
        onClose={() => close(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>{state.title}</DialogTitle>
        <DialogContent>
          {React.isValidElement(state.message) ? (
            state.message
          ) : (
            <Typography
              sx={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                color: "text.secondary",
              }}
            >
              {String(state.message || "")}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          {state.type === "confirm" ? (
            <>
              <Button onClick={() => close(false)} variant="text">
                {t("dialog.buttons.cancel")}
              </Button>
              <Button onClick={() => close(true)} variant="contained" autoFocus>
                {t("dialog.buttons.ok")}
              </Button>
            </>
          ) : (
            <Button onClick={() => close()} variant="contained" autoFocus>
              {t("dialog.buttons.ok")}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </DialogContext.Provider>
  );
}

export function useDialog() {
  return (
    useContext(DialogContext) || {
      alert: (m) => window.alert(m),
      confirm: (m) => window.confirm(m),
    }
  );
}
